export class NoiseCancelationNode extends AudioWorkletNode {

    static async init(audioCtx: AudioContext) {
        await audioCtx.audioWorklet.addModule('/NoiseCancelation.audioworkletprocessor.js');
    }

    constructor(audioCtx: AudioContext) {
        super(audioCtx, 'NoiseCancelationProcessor');
    }

}